<app-organizer-shared-layout-funnel class="organizer-shared-form-wrapper">
  <app-organizer-shared-page-container
    [activeStep]="activeStep"
    [tipsConfig]="tipsConfig"
    [watchTipsChanges]="watchTipsChanges"
  >
    <form (ngSubmit)="submit()">
      <app-section [description]="sectionDescription" [title]="sectionTitle">
        <ng-content></ng-content>
      </app-section>

      <app-organizer-shared-navigation-buttons
        [nextDisabled]="isNextDisabled"
        [nextSubmit]="true"
        [previousNavigationExtras]="previousNavigationExtras"
        [previousQueryParametersHandling]="previousQueryParametersHandling"
        [previousUrl]="previousUrl"
        [hasPreviousButton]="hasPreviousButton"
        (clickNext)="clickNextNavigationButton()"
      ></app-organizer-shared-navigation-buttons>
    </form>
  </app-organizer-shared-page-container>
</app-organizer-shared-layout-funnel>
